import React from "react";
import { PaymentInfoTemplate } from "themes/application/payment/components";

const PaymentInfo = (props) => {
    return <PaymentInfoTemplate {...props} />;
};

export default PaymentInfo;
